import { gql } from '@apollo/client';

export const GET_CONSENT_FORMS_BY_COMPANY = gql`
  query ConsentForms($companyId: ID!) {
    consentForms(companyId: $companyId) {
      id
      name
      company {
        id
        name
      }
      fileKey
      filePath
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_CONSENT_FORM_BY_ID = gql`
  mutation DeleteConsentForm($id: ID!) {
    deleteConsentForm(id: $id) {
        consentForm {
            id
        }
    }
  }
`;

export const GET_IS_COMPANY_CONSENT_FORM_REQUIRED = gql`
  query CompanyConsentFormRequired($companyId: ID!) {
    company(id: $companyId) {
      consentFormRequired
    }
  }
`;

export const GET_PROJECT_CONSENT_FORMS = gql`
  query ProjectConsentForms($projectId: ID!) {
    project(id: $projectId) {
      projectConsentForms {
        id,
        consentForm {
          id,
          name,
          filePath
        }
      }
    }
  }
`;

export const GET_CONSENT_FORM_BY_ID = gql`
  query ConsentForms($consentFormId: ID!) {
    consentForm(id: $consentFormId) {
      id
      name
      company {
        id
        name
      }
      fileKey
      filePath
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_COMPANY_CONSENT_FORM_REQUIRED = gql`
  mutation UpdateCompanyConsentFormRequired($id: ID!, $consentFormRequired: Boolean!) {
    updateCompanyConsentFormRequired(
        id: $id,
        consentFormRequired: $consentFormRequired
    ){
        company {
          id,
          consentFormRequired
        }
        errors
    }
  }
`;

export const CREATE_CONSENT_FORM = gql`
  mutation CreateConsentForm($name: String!, $companyId: ID!, $fileKey: String!) {
    createConsentForm(name: $name, companyId: $companyId, fileKey: $fileKey) {
      consentForm {
        id
        name
        company {
          id
          name
        }
        filePath
      }
    }
  }
`;
